import axiosInstance from "@/api/axiosInstance";
import { CreateAdminUserRequest, CreateAdminUserResponse } from "./types";

export const createAdminUser = async (
  data: CreateAdminUserRequest,
): Promise<CreateAdminUserResponse> => {
  const response = await axiosInstance.post<CreateAdminUserResponse>(
    "/api/private/admin/employees/create",
    data,
  );
  return response.data;
};
